<template>
  <div>
    <div style="height: 36px;">
      <h3 class="font-size-lg text-dark font-weight-bold mb-6 telefone-title">
        Registros Eletrônicos:
      </h3>
      <a
        href="javascript:;"
        @click="adicionar"
        class="btn btn-light-primary btn-sm font-weight-bolder mr-2 btn-adicionar"
      >
        <i v-if="!loading" class="ki ki-plus icon-sm"></i> Adicionar
      </a>
    </div>

    <b-list-group class="list-scroll" style="max-height: 258px; overflow-y: auto;">
      <b-list-group-item v-for="(registro, index) in registros" :key="index">
        <div class="row">
          <div class="col-md-12">
            <button type="button" aria-label="Remover" class="close" @click="remover(index)">
              <div class="alert-close">
                <span aria-hidden="true"><i class="la la-close"></i></span>
              </div>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <b-form-group label="Descrição:">
              <b-form-input
                type="text"
                v-model="registro.DESCRICAO"
                placeholder="Descrição"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Endereço eletrônico:">
              <b-form-input
                type="text"
                v-model="registro.NOME"
                placeholder="Endereço eletrônico"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Usuário:">
              <b-form-input
                type="text"
                v-model="registro.LOGIN"
                placeholder="Usuário"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="Senha:">
              <b-form-input
                type="text"
                v-model="registro.SENHA"
                placeholder="Senha"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
      </b-list-group-item>
      <b-list-group-item v-if="!registros.length">
        <div class="row">
          <div class="col-md-12">
            <h3 class="font-size-lg text-dark font-weight-bold mb-6" style="font-size: 12px; margin-top: 0px; margin-bottom: 0 !important;">
              Sem registros adicionados.
            </h3>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "EmitenteRegistros",
  data() {
    return {
      loading: false,
      registros: []
    };
  },
  props: ["idEmitente", "registrosEmitente"],
  async mounted() {
    
  },
  methods: {
    ...mapActions(["getConfiguracaoMaster"]),
    atribuirRegistros() {
      this.registros = [];
      if((this.registrosEmitente) && (this.registrosEmitente.length)) {
        this.registrosEmitente.forEach((registro) => this.registros.push(registro));
      }
    },
    adicionar() {
      this.registros.push({});

      this.$nextTick(() => {
        let container = this.$el.querySelector(".list-scroll");
        container.scrollTop = container.scrollHeight;
      });
    },
    remover(index) {
      this.registros.splice(index, 1);
    },
    retornar() {
      return this.registros;
    }
  }
};
</script>

<style lang="scss" scoped>
.telefone-title {
  position: absolute;
}

@media (min-width: 1200px) {
  .telefone-title {
    margin-top: 3px;
  }
}

@media (max-width: 1199px) {
  .telefone-title {
    margin-top: 3px;
  }
}

.btn-adicionar {
  position: absolute;
}

@media (min-width: 1200px) {
  .btn-adicionar {
    margin-top: -7px;
    right: 23px;
  }
}

@media (max-width: 1199px) {
  .btn-adicionar {
    margin-top: -4px;
    right: 21px;
  }
}

.list-scroll::-webkit-scrollbar {
  width: 10px;
}

.list-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.list-scroll::-webkit-scrollbar-thumb {
  background: #888;
}

.list-scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
